import { GetOfficeDirectoryList, CreateOffice, UpdateOffice, UpdateStatusOffice } from '@/actions/directoryActions.js'
import { normalizeDirectoryText, showDirectoryPageWithRecord } from '@/helpers/directoryPagination.js'

const findDirectoryRecord = (list, matches) => Array.isArray(list?.docs)
    ? list.docs.find(matches)
    : null

const state ={
    officeList :{
        docs: [],
        totalPages : 0,
    },
    officeDataUpdate : {
        regionId : ""
    },
    search : '',
    page : 1,
    highlightedOfficeId : ''
}
const getters = {
    officeList : state => state.officeList,
    officeDataUpdate : state => state.officeDataUpdate,
    officeSearch : state => state.search,
    officePage : state => state.page,
    highlightedOfficeId : state => state.highlightedOfficeId
}
const actions = {
    async GetOfficeList({commit},data = { page : 1, search : ''}){
        let search = data.search || ''
        let page = data.page || 1

        commit('setOfficePage',page)
        commit('setOfficeSearch',search)
        const list =  await GetOfficeDirectoryList(search,page).catch()
        
        if(list){
            commit('setOfficeList',list)
        }

        return list
    },
    async CreateOfficeRun({dispatch, commit},data){
        const create = await CreateOffice(data).catch()
        if(create=="OK"){
            const createdOfficeName = normalizeDirectoryText(data.officeName)
            const createdRegionId = data.regionId
            const matches = (office) => {
                const officeRegionId = office.regionId?._id || office.regionId
                return normalizeDirectoryText(office.officeName) === createdOfficeName && officeRegionId === createdRegionId
            }
            const firstPage = await dispatch('GetOfficeList', { page : 1, search : ''})
            const pageData = await showDirectoryPageWithRecord({
                firstPage,
                loadPage: (page) => dispatch('GetOfficeList', { page, search : ''}),
                matches
            })
            const matchedOffice = findDirectoryRecord(pageData, matches)
            commit('setHighlightedOfficeId', matchedOffice?._id || '')
        }

        return create
    },
    async UpdateOfficeRun({dispatch, commit},data){
        const {officeSearch} = this.getters

        const update = await UpdateOffice(data).catch()
        if(update=="OK")
        {
            const updatedOfficeName = normalizeDirectoryText(data.officeName)
            const updatedRegionId = data.regionId
            const matches = (office) => {
                const officeRegionId = office.regionId?._id || office.regionId
                return (data._id && office._id === data._id) ||
                    (normalizeDirectoryText(office.officeName) === updatedOfficeName && officeRegionId === updatedRegionId)
            }
            const loadMatchingPage = async (search) => {
                const firstPage = await dispatch('GetOfficeList',{ page : 1, search })
                const pageData = await showDirectoryPageWithRecord({
                    firstPage,
                    loadPage: (page) => dispatch('GetOfficeList', { page, search }),
                    matches
                })
                const matchedOffice = findDirectoryRecord(pageData, matches)
                if(matchedOffice){
                    commit('setHighlightedOfficeId', matchedOffice._id)
                    return true
                }

                return false
            }

            commit('setHighlightedOfficeId', '')
            if(!(await loadMatchingPage(officeSearch || '')) && officeSearch){
                await loadMatchingPage('')
            }
        }

        return update
    },
    async UpdateOfficeStatus(obj, data){
        const update = await UpdateStatusOffice(data).catch()
        if(update=="OK"){
            const officeList = this.getters.officeList.docs
            const index = officeList.findIndex((u)=>u._id===data)
            officeList[index].status = !officeList[index].status
        }

        return update
    },
    AppendOfficeUpdateData({commit},data){
        commit('setOfficeDataUpdate',data)
    },
    ClearOfficeHighlight({commit}){
        commit('setHighlightedOfficeId','')
    }

}
const mutations = {
    setOfficeList : (state, data) => (state.officeList = data),
    setOfficeDataUpdate : (state, data) => (state.officeDataUpdate = data),
    setOfficeSearch : (state, data) => (state.search = data),
    setOfficePage : (state, data) => (state.page = data),
    setHighlightedOfficeId : (state, data) => (state.highlightedOfficeId = data),
}


export default {
    state,
    getters,
    actions,
    mutations
}
